import { signal } from '@angular/core';
import { debounce, FieldTree, max, min, required, SchemaPathTree } from '@angular/forms/signals';
import { AmbientTemperatureDto } from '../../../../core/mceapi.client.generated';

export interface AmbientTemperature {
  airTemperature: number;
  groundTemperature: number;
}

export function defaultAmbientTemperature(defaultAirTemperature: number, defaultGroundTemperature: number): AmbientTemperature {
  return {
    airTemperature: defaultAirTemperature,
    groundTemperature: defaultGroundTemperature,
  };
}

export function buildAmbientTemperatureSchema(path: SchemaPathTree<AmbientTemperature>) {

  required(path.airTemperature, { message: `Air temperature is required` });
  min(path.airTemperature, -40, { message: `Air temperature must be above -40°C` });
  max(path.airTemperature, 120, { message: `Air temperature must be below 120°C` });
  debounce(path.airTemperature, 500);

  required(path.groundTemperature, { message: `Ground temperature is required` });
  min(path.groundTemperature, -40, { message: `Ground temperature must be above -40°C` });
  max(path.groundTemperature, 120, { message: `Ground temperature must be below 120°C` });
  debounce(path.groundTemperature, 500);
}

//export function isValidAmbientTemperature(model: FieldTree<AmbientTemperature>) {
//  return model.airTemperature().valid() && model.groundTemperature().valid();
//}

//export function isDirtyAmbientTemperature(model: FieldTree<AmbientTemperature>) {
//  return model.airTemperature().dirty() || model.groundTemperature().dirty();
//}

export function createAmbientTemperature(dto: AmbientTemperatureDto) {
  const airTemperature = dto.airTemperature?.temperature;
  const groundTemperature = dto.groundTemperature?.temperature;

  if (airTemperature === undefined || groundTemperature === undefined) {
    throw new Error('Ambient temperature DTO is missing required values.');
  }

  return signal<AmbientTemperature>({
    airTemperature,
    groundTemperature,
  });
}

export function createAmbientTemperatureDto(model: FieldTree<AmbientTemperature>) {
  return signal<AmbientTemperatureDto>({
    airTemperature: { temperature: model.airTemperature().value() },
    groundTemperature: { temperature: model.groundTemperature().value() },
  });
}
